<template>
    <div class="main">
        <c-panel :title="modoEdicao ? 'EDITAR CONFIGURAÇÃO DE FREQUÊNCIA' : 'NOVA CONFIGURAÇÃO DE FREQUÊNCIA'" titleIcon="fas fa-edit">

            <div v-if="!carregado" class="u-text-center u-mt-25">
                <img src="/public/img/loading-bar.gif" />
            </div>

            <el-form v-else label-position="top" :model="dados" ref="dados" @submit.native.prevent="salvar">

                <el-alert type="info" :closable="false" class="u-mb-15"
                    title="A configuração registra a política de apuração. A quantidade de horários da turma não é alterada por ela — quem define os lançamentos do diário continua sendo a própria turma."></el-alert>

                <el-alert v-if="bloqueio && bloqueio.pode === false" type="warning" :closable="false" class="u-mb-15" :title="bloqueio.motivo"></el-alert>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Escopo" prop="escopo" :rules="[$requiredChange]">
                            <el-select v-model="dados.escopo" style="width: 100%;" @change="aoTrocarEscopo">
                                <el-option v-for="e in escopos" :key="e" :value="e" :label="rotuloEscopo(e)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10" v-if="dados.escopo && dados.escopo !== 'rede'">
                        <el-form-item :label="rotuloAlvo">
                            <el-select v-model="dados.escopo_id" filterable style="width: 100%;" @change="verificarBloqueio">
                                <el-option v-for="o in alvos" :key="o.id" :value="o.id" :label="o.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Período letivo" prop="periodo_letivo_id" :rules="[$requiredChange]">
                            <el-select v-model="dados.periodo_letivo_id" style="width: 100%;" @change="verificarBloqueio">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Modo de apuração">
                            <el-select v-model="dados.modo_apuracao" style="width: 100%;">
                                <el-option value="dia" label="Por dia"></el-option>
                                <el-option value="aula" label="Por aula"></el-option>
                                <!-- BLOCO Q — item 17 -->
                                <el-option value="total_periodo" label="Total de faltas no período"></el-option>
                            </el-select>
                            <!-- BLOCO Q: o operador precisa saber ANTES de gravar que este
                                 modo desliga a Busca Ativa para as turmas alcançadas. -->
                            <el-alert
                                v-if="dados.modo_apuracao === 'total_periodo'"
                                type="warning" show-icon :closable="false" style="margin-top: 8px;"
                                title="Sem data das faltas neste modo"
                                :description="avisoSemData">
                            </el-alert>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Modalidade">
                            <el-select v-model="dados.modalidade_id" style="width: 100%;" clearable placeholder="Todas">
                                <el-option v-for="m in modalidades" :key="m.id" :value="m.id" :label="m.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Nível escolar">
                            <!--
                                Era input livre com máscara de 2 dígitos: o operador tinha de
                                saber de cor que 0 é infantil, 1 é fundamental I e 2 é
                                fundamental II, e digitar 3 gravava um nível inexistente — a
                                configuração ficava salva e nunca casava com turma alguma.
                                `$CONSTANTS.ETAPA` é a mesma legenda da matriz curricular.
                            -->
                            <el-select v-model="dados.nivel_escolar" clearable
                                placeholder="Todos" style="width: 100%;">
                                <el-option v-for="(rotulo, v) in $CONSTANTS.ETAPA" :key="v"
                                    :label="rotulo" :value="parseInt(v)"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="4">
                        <el-form-item label="Freq. mínima (%)">
                            <el-input v-model="dados.frequencia_minima" v-mask="'###,##'" placeholder="75"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4">
                        <el-form-item label="Abono de falta">
                            <el-select v-model="dados.permite_abono" style="width: 100%;">
                                <el-option :value="true" label="PERMITE"></el-option>
                                <el-option :value="false" label="NÃO PERMITE"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <small style="color: #909399;">Modalidade e nível escolar em branco significam "qualquer".</small>

                <el-row class="u-mt-15">
                    <el-col :xs="24" class="u-text-right">
                        <router-link to="/admin/configuracao-frequencia">
                            <el-button>VOLTAR</el-button>
                        </router-link>
                        <el-button class="u-ml-10" type="primary" native-type="submit">SALVAR</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </c-panel>
    </div>
</template>

<script>
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        dados: {
            escopo: 'rede', escopo_id: '', periodo_letivo_id: '', modo_apuracao: 'dia',
            // Texto do aviso vem do backend (initForm); este é apenas o fallback.
            avisoSemData: 'Neste modo não há registro de data das faltas. A Busca Ativa não poderá ser executada para as turmas alcançadas por esta configuração.',
            modalidade_id: '', nivel_escolar: null, frequencia_minima: '', permite_abono: true
        },
        escopos: [], modalidades: [], alvos: [],
        bloqueio: null,
        modoEdicao: false,
        carregado: false
    }),
    computed: {
        rotuloAlvo () {
            const r = { instituicao: 'Instituição', matriz_etapa: 'Etapa da matriz curricular', turma: 'Turma' }
            return r[this.dados.escopo] || 'Alvo'
        }
    },
    mounted () { this.initForm() },
    methods: {
        rotuloEscopo (e) {
            const r = { rede: 'Rede (toda a rede)', instituicao: 'Instituição', matriz_etapa: 'Etapa da matriz', turma: 'Turma' }
            return r[e] || e
        },
        initForm () {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/initForm`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.escopos = r.data.escopos || []
                this.modalidades = r.data.modalidades || []
                this.dados.periodo_letivo_id = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : ''
                if (this.$route.params.id) {
                    this.modoEdicao = true
                    this.carregar(this.$route.params.id)
                } else {
                    this.carregado = true
                }
            }).catch(e => this.$store.commit('throwException', e))
        },
        aoTrocarEscopo () {
            this.dados.escopo_id = ''
            this.alvos = []
            this.bloqueio = null
            const inst = this.$store.state.config.instituicao
            const periodo = this.$store.state.config.periodo

            if (this.dados.escopo === 'turma' && inst && inst.id) {
                this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${inst.id}/${periodo.id}`,
                    this.$store.getters.getHeaderAuth
                ).then(r => { this.alvos = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat() }).catch(() => {})

            } else if (this.dados.escopo === 'instituicao') {
                this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                    this.$store.getters.getHeaderAuth
                ).then(r => { this.alvos = Array.isArray(r.data) ? r.data : [] }).catch(() => {})

            } else if (this.dados.escopo === 'matriz_etapa') {
                this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/getAll`,
                    this.$store.getters.getHeaderAuth
                ).then(r => {
                    const matrizes = Array.isArray(r.data) ? r.data : []
                    const chamadas = matrizes.map(m => this.$axios.get(
                        `${this.$store.state.config.baseUrlApi}/api/matriz-curricular/etapas/${m.id}`,
                        this.$store.getters.getHeaderAuth
                    ).then(res => (res.data || []).map(e => ({ id: e.id, nome: m.nome + ' — ' + e.nome }))))
                    Promise.all(chamadas).then(listas => { this.alvos = [].concat.apply([], listas) })
                }).catch(() => {})
            }
        },
        // Item 102: o backend informa se já existem lançamentos no escopo.
        verificarBloqueio () {
            this.bloqueio = null
            if (!this.dados.escopo || !this.dados.periodo_letivo_id) return
            if (this.dados.escopo !== 'rede' && !this.dados.escopo_id) return
            this.$axios.post(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/podeAlterar`,
                { escopo: this.dados.escopo, escopo_id: this.dados.escopo_id, periodo_letivo_id: this.dados.periodo_letivo_id },
                this.$store.getters.getHeaderAuth
            ).then(r => { if (r.data && !r.data.erro) this.bloqueio = r.data }).catch(() => {})
        },
        carregar (id) {
            this.$axios.get(
                `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/getById/${id}`,
                this.$store.getters.getHeaderAuth
            ).then(r => {
                const reg = r.data || {}
                Object.keys(this.dados).forEach(k => {
                    if (reg[k] !== undefined && reg[k] !== null) this.dados[k] = reg[k]
                })
                this.dados.permite_abono = reg.permite_abono === false ? false : true
                this.aoTrocarEscopoManterAlvo(reg.escopo_id)
                this.verificarBloqueio()
                this.carregado = true
            }).catch(e => this.$store.commit('throwException', e))
        },
        aoTrocarEscopoManterAlvo (escopoId) {
            const alvo = this.dados.escopo_id
            this.aoTrocarEscopo()
            this.$nextTick(() => { this.dados.escopo_id = escopoId || alvo })
        },
        salvar () {
            this.$refs.dados.validate(valid => {
                if (!valid) {
                    window.eventBus.$emit('alert', { msg: 'Preencha os campos obrigatórios.', type: 'warning' })
                    return
                }
                window.eventBus.$emit('loading', true)
                const url = this.modoEdicao
                    ? `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/update/${this.$route.params.id}`
                    : `${this.$store.state.config.baseUrlApi}/api/configuracao-frequencia/store`
                this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth).then(r => {
                    window.eventBus.$emit('loading', false)
                    if (r.data && r.data.erro) {
                        window.eventBus.$emit('alert', { msg: typeof r.data.erro === 'string' ? r.data.erro : r.data.erro.text, type: 'warning' })
                        return
                    }
                    window.eventBus.$emit('alert', { msg: 'Salvo com sucesso.', type: 'success' })
                    this.$router.push('/admin/configuracao-frequencia')
                }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
            })
        }
    }
}
</script>
